import { createQueryStringToggleHook } from "../../../../stores/useQueryState";

export const useAccesssoryCategories = createQueryStringToggleHook(
  "accessory-categories",
  []
);
